import { useFormContext } from 'react-hook-form';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { FORM_ID, SUBMIT_SETUP_STEP } from './constants';

export const ReviewChangesButton = () => {
  const {
    formState: { submitCount, isValid },
  } = useFormContext();

  return (
    <SecondaryButton
      type="submit"
      size={BUTTON_SIZES.LARGE}
      form={FORM_ID}
      isDisabled={submitCount > 0 && !isValid}
    >
      {SUBMIT_SETUP_STEP}
    </SecondaryButton>
  );
};
